import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "../src/style/components/DefaultComponent.css";
import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";
import { storeSelectedCompany, storeSelectedPerson } from "./utils/auth";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      {" "}
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        console.log("Firebase service worker registered:", registration);
      })
      .catch((err) => {
        console.error("Service worker registration failed:", err);
      });
  });
}
if (navigator.serviceWorker) {
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data?.type === "NOTIFICATION_CLICK") {
      // console.log(event.data.payload, "NOTIFICATION_CLICK");
      // console.log(event.data.payload.name);
      storeSelectedPerson(event.data.payload);
      storeSelectedCompany(event.data.payload.company_details[0]);
    }
  });
}
